import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Landing from "./Components/Pages/Landing/Landing";
import Dashboard from "./Components/Pages/Dashboard/Dashboard";
import Send from "./Components/Pages/Send/Send";
import Login from "./Components/Pages/Auth/Login";
import Register from "./Components/Pages/Auth/Register";
import { jwtDecode } from "jwt-decode";
import toast from "react-hot-toast";
import MyDashboard from "./Components/Pages/Home";
import AdminLogin from "./Components/Admin/Auth/AdminLogin";
import UserDashboard from "./Components/Admin/Dashboard/AdminDashboard";

const App = () => {
  const isTokenExpired = () => {
    const token = sessionStorage.getItem("_token");
    if (!token) return true;

    try {
      const decodedToken = jwtDecode(token);
      return decodedToken.exp * 1000 < Date.now();
    } catch (error) {
      console.error("Invalid token:", error);
      return true;
    }
  };

  const isAuthenticated = () => {
    const token = sessionStorage.getItem("_token");
    return token && !isTokenExpired();
  };

  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/Register" element={<Register />} />
        <Route path="/Login" element={<Login />} />
        <Route
          path="/dashboard" element={<MyDashboard />}
        // element={isAuthenticated() ? <MyDashboard /> : <Navigate to="/Login" />}
        />
        <Route
          path="/send"
          element={isAuthenticated() ? <Send /> : <Navigate to="/Login" />}
        />
        <Route path="/Admin/Login" element={<AdminLogin />} />
        <Route
          path="/Admin/Dashboard"
          element={<UserDashboard />}
        // element={isAuthenticated() ? <UserDashboard /> : <Navigate to="/Admin/Login" />}
        />
      </Routes>
    </>
  );
};

export default App;
